<template>

    <div class="item">

        <div class="name mb-10">
            <router-link :to="{ name: 'traits-edit', params: { id: trait.id } }">{{ trait.name }}</router-link>
        </div>

        <form @submit.prevent="updateTrait">
            <v-button-toolbar class="mb-10">
                <v-select v-if="type === 'boolean'" size="sm" :model="Boolean(params.value)" @input="params.value = $event" :disabled="disabled">
                    <option :value="true">True</option>
                    <option :value="false">False</option>
                </v-select>
                <v-date-picker v-else-if="type === 'date'" size="sm" :model="params.value" @input="params.value = $event" :disabled="disabled" />
                <v-input v-else size="sm" :model="params.value" @input="params.value = $event" :disabled="disabled" />
                <v-button v-if="!disabled" tabindex="-1" size="sm" btn-style="white" :loading="loading" @click.native="updateTrait">Save</v-button>
            </v-button-toolbar>
        </form>

        <v-value v-if="hasNewValue" class="value" :value="newValue" />
        <v-value v-else class="value" :value="customer | valueForTrait(trait)" />

    </div>

</template>

<style scoped lang="scss">

    .item {
        border-bottom: 1px solid $color-rule-light;
        margin-bottom: 15px;
        padding-bottom: 15px;
        .name {
            @include font-medium(13px);
            color: $color-text;
            line-height: normal;
            a {
                color: $color-text;
            }
        }
        .value {
            @include font-medium(12px);
            color: $color-muted;
            line-height: normal;
        }
    }

</style>

<script>

import CustomerApi from '@api/CustomerApi';
import StringUtil from '@utils/StringUtil';

export default {

    props: {
        trait: {
            type: Object,
            required: true,
        },
        customer: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loading: false,
            hasNewValue: false,
            newValue: null,
            params: {},
        }
    },

    computed: {

        type() {
            return this.trait.type;
        },

    },

    created() {
        this.params.field = this.trait.field;
        this.params.value = this.traitValue();
    },

    methods: {

        updateTrait() {
            this.loading = true;
            CustomerApi.updateTrait(this.customer.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.hasNewValue = true;
                    this.newValue = StringUtil.formatValue(this.trait, response.data.data);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

        traitValue() {
            let val = '';
            let i = this.trait.field.split('.');
            if (i.length === 1) {
                val = this.customer?.[i[0]] ? this.customer[i[0]] : '';
            } else if (i.length === 2) {
                val = this.customer?.[i[0]]?.[i[1]] ? this.customer[i[0]][i[1]] : '';
            } else if (i.length === 3) {
                val = this.customer?.[i[0]]?.[i[1]]?.[i[2]] ? this.customer[i[0]][i[1]][i[2]] : '';
            }
            return val;
        },

    },

}

</script>
